import React, { useState } from "react";
import { auth } from "../firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { db } from "../firebaseConfig";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import "./AdminCreateUser.css"; // ✅ Import your CSS here

const AdminCreateUser = () => {
  const [showForm, setShowForm] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const [org, setOrg] = useState("");
  const [status, setStatus] = useState("");

  const handleCreateUser = async () => {
    if (!email || !password || !org) {
      setStatus("Please fill in all fields");
      return;
    }

    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      const uid = userCred.user.uid;

      await setDoc(doc(db, "users", uid), {
        email,
        role,
        org,
        createdAt: serverTimestamp()
      });

      setStatus("✅ User created successfully");
      setEmail("");
      setPassword("");
      setOrg("");
    } catch (error) {
      console.error("Error creating user:", error);
      setStatus("❌ Failed to create user");
    }
  };

  return (
    <>
      <button className="create-user-btn" onClick={() => setShowForm(!showForm)}>
        ➕ Create User
      </button>

      {showForm && (
        <div className="create-user-overlay" onClick={() => setShowForm(false)}>
          <div className="create-user-form" onClick={(e) => e.stopPropagation()}>
            <h2>Create New User</h2>
            <input
              type="email"
              placeholder="User Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <input
              type="text"
              placeholder="Organization Name"
              value={org}
              onChange={(e) => setOrg(e.target.value)}
            />
            <select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value="user">Individual User</option>
              <option value="org_admin">Org Admin</option>
            </select>
            <div className="actions">
              <button onClick={handleCreateUser}>Create</button>
              <button onClick={() => setShowForm(false)}>Cancel</button>
            </div>
            {status && <p>{status}</p>}
          </div>
        </div>
      )}
    </>
  );
};

export default AdminCreateUser;
